import { Grid } from '@chakra-ui/react';
import { ContractSearchResponseDTO } from 'models';
import formatter from 'utils/formatter';
import { DetailItem } from './DetailItem';

interface ViewFormProps {
  contract: ContractSearchResponseDTO;
}

export const ViewContractFormReadOnly = ({ contract }: ViewFormProps) => {
  return (
    <Grid templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }} gap={4}>
      <DetailItem label="Nº do Contrato" value={contract.numeroContrato} />
      <DetailItem label="Nº Registro Contrato" value={contract.numeroRegistroContrato} />
      <DetailItem label="Status" value={contract.status} />
      <DetailItem label="Data do Contrato" value={formatter.data(contract.dataContrato)} />
      <DetailItem label="UF do Contrato" value={contract.ufContrato} />
      <DetailItem label="Nº do Gravame/Restrição" value={contract.numeroGravame} />
      <DetailItem label="UF do Gravame" value={contract.ufGravame} />
      <DetailItem label="Tipo de Restrição" value={contract.tipoRestricao} />
      <DetailItem label="Nº do Aditivo " value={contract.numeroAditivo} />
      <DetailItem label="Data do Aditivo" value={formatter.data(contract.dataAditivo)} />
      <DetailItem label="Nº Registro Contrato" value={contract.registroAditivo} />
    </Grid>
  );
};